'use strict';

angular.module('ntmApp')
  .filter('firstChar', function () {

      return function (input) {
          return input ? input.split('')[0] : '';
      };
  });